import { ExtraOptions, Routes } from '@angular/router';
import { contractAssetsRoutes } from '@visiativ/contract-assets-front';
import {
	accountRoutes,
	InviteRedirectComponent,
	inviteLogoutGuard,
} from '@visiativ/digital-account-front';
import { digitalDownloadCenterFrontRoutes } from '@visiativ/digital-download-center-front';
import { buildingBlockHelpdeskRoutes } from '@visiativ/digital-helpdesk-front';
import { projectRoutes } from '@visiativ/digital-project-front';
import {
	mySessionCenterFrontRoutes,
	trainingCenterFrontRoutes,
} from '@visiativ/training-center-front';
import { LoggedComponent } from './core/components/logged/logged.component';
import { LogoutComponent } from './core/components/logout/logout.component';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { ChangePasswordComponent } from './portal/pages/change-password/change-password.component';
import { LegalDocumentsComponent } from './portal/pages/legal-documents/legal-documents.component';

export const routes: Routes = [
	{
		path: 'invite',
		component: InviteRedirectComponent,
		canActivate: [inviteLogoutGuard],
	},
	{
		path: '',
		pathMatch: 'full',
		redirectTo: '/home',
	},
	{
		path: 'logged',
		component: LoggedComponent,
	},
	{
		path: 'logout',
		component: LogoutComponent,
	},
	{
		path: 'page-not-found',
		component: PageNotFoundComponent,
	},
	{
		path: 'home',
		loadComponent: () =>
			import('./portal/pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
	},
	{
		path: 'menu',
		loadComponent: () => import('./portal/pages/menu/menu.component').then(m => m.MenuComponent),
	},
	{
		path: 'legal_documents',
		children: [
			{ path: '', component: LegalDocumentsComponent },
			{ path: 'privacy_policy', component: LegalDocumentsComponent },
			{ path: 'cgu', component: LegalDocumentsComponent },
			{ path: 'legal_notice', component: LegalDocumentsComponent },
		],
	},
	{
		path: 'my_communities',
		loadComponent: () =>
			import('./portal/pages/my-communities/my-communities.component').then(
				m => m.MyCommunitiesComponent,
			),
	},
	{ path: '', children: buildingBlockHelpdeskRoutes },
	{ path: 'projects', children: projectRoutes },
	{ path: 'download-center', children: digitalDownloadCenterFrontRoutes },
	{ path: '', children: accountRoutes },
	{ path: '', children: contractAssetsRoutes },
	{ path: 'training', children: trainingCenterFrontRoutes },
	{ path: 'my-sessions', children: mySessionCenterFrontRoutes },
	{
		path: 'change-password',
		component: ChangePasswordComponent,
	},
	{
		path: '**',
		redirectTo: 'page-not-found',
	},
];

export const routesConfig: ExtraOptions = {
	initialNavigation: 'enabledNonBlocking',
};
